import Layout from '@/layout'
const routesMap = {
  layout: Layout,
  product:()=>import('@/views/product/onlineManage'),
  productOnlineManage:()=>import('@/views/product/onlineManage'),//线上商品管理
  productUnderManage:()=>import('@/views/product/underManage'),//线下商品管理
  productDraft:()=>import('@/views/product/draft'),//线上草稿管理
  seller:()=>import('@/views/seller/sellerList'),//商户管理
  sellerList:()=>import('@/views/seller/sellerList'),//商户管理
  sellerApprove:()=>import('@/views/seller/sellerApprove'),//商户审批
  sellerSubordinate:()=>import('@/views/seller/subordinate'),//子商户管理
  sellerRelation:()=>import('@/views/seller/relation'),//商户关系管理
  operation:()=>import('@/views/operation/liveBroadcast'),//运营管理start
  liveBroadcast:()=>import('@/views/operation/liveBroadcast'),
  socialGroup:()=>import('@/views/operation/socialGroup'),
  socialGroupDynamic:()=>import('@/views/operation/socialGroupDynamic'),
  shortActivity:()=>import('@/views/operation/shortActivity'), // 燊鲜GO
  summaryData:()=>import('@/views/operation/summaryData'),  // 汇总数据
  blackList:()=>import('@/views/operation/blackList'), // 黑名单维护
  priceContrast:()=>import('@/views/operation/priceContrast'),//商品价格对比表
  memberList:()=>import('@/views/memberManage/memberList'),//会员管理start
  memberPoint:()=>import('@/views/memberManage/memberPoint'),
  memberAuthentica:()=>import('@/views/memberManage/memberAuthentica'),
  manageType:()=>import('@/views/memberManage/manageType'),
  reportConfig:()=>import('@/views/memberManage/reportConfig'),
  assetManage:()=>import('@/views/assetManage/billManage'), //资产管理start
  settleManage:()=>import('@/views/assetManage/settleManage'),
  reconciManage:()=>import('@/views/assetManage/reconciManage'),
  billManage:()=>import('@/views/assetManage/billManage'),
  withdrawManage:()=>import('@/views/assetManage/withdrawManage'),
  userRechargeOrder:()=>import('@/views/assetManage/userRechargeOrder'),
  userCashTopUp:()=>import('@/views/assetManage/userCashTopUp'),
  reportDownload:()=>import('@/views/assetManage/reportDownload'),
  summaryManagement: ()=>import('@/views/assetManage/summaryManagement'),
  topUpOrderCancel: ()=>import('@/views/assetManage/topUpOrderCancel'),
  redRush:()=>import('@/views/orderManage/redRush'), // 红冲
  //营销管理start
  activityList:()=>import('@/views/marketingManage/activityList'),
  activityAuditList:()=>import('@/views/marketingManage/activityAuditList'),
  redpacketList:()=>import('@/views/marketingManage/redpacketList'),
  redpacketAuditList:()=>import('@/views/marketingManage/redpacketAuditList'),
  redpacketTrackList:()=>import('@/views/marketingManage/redpacketTrackList'),
  couponsList:()=>import('@/views/marketingManage/couponsList'),
  couponsAuditList:()=>import('@/views/marketingManage/couponsAuditList'),
  couponsTrackList:()=>import('@/views/marketingManage/couponsTrackList'),
  issueList:()=>import('@/views/marketingManage/issueList'),
  issueAuditList:()=>import('@/views/marketingManage/issueAuditList'),
  //营销管理end
  sysCategory:()=>import('@/views/category/sysCategory'),
  virtualCategory:()=>import('@/views/category/virtualCategory'),
  sys:()=>import('@/views/sysManage/roleList'),
  menuList:()=>import('@/views/sysManage/menuList'),
  roleList:()=>import('@/views/sysManage/roleList'),
  adminList:()=>import('@/views/sysManage/adminList'),
  accountList:()=>import('@/views/sysManage/accountList'),
  logisticsList:()=>import('@/views/sysManage/logisticsList'),
  specialCommoditySettlement:()=>import('@/views/sysManage/specialCommoditySettlement'),
  whiteList:()=>import('@/views/sysManage/whiteList'),
  msgList:()=>import('@/views/sysManage/msgList'),
  delayList: ()=>import('@/views/sysManage/delayList'),// 定时器补偿}
  afterWhyList:()=>import('@/views/sysManage/afterWhyList'),
  businessConfig:()=>import('@/views/sysManage/businessConfig'),
  warehouse:()=>import('@/views/sysManage/warehouse'),
  config:()=>import('@/views/configManage/configList'),
  configList:()=>import('@/views/configManage/configList'),
  placeList:()=>import('@/views/configManage/placeList'),
  faqList:()=>import('@/views/configManage/faqList'), // 常见问题管理
  searchList:()=>import('@/views/configManage/searchList'), // 搜索配置
  agreementList:()=>import('@/views/configManage/agreementList'), // 协议管理
  reprintReason:()=>import('@/views/configManage/reprintReason'), // 补打原因配置
  purchaseConfig:()=>import('@/views/configManage/purchaseConfig'), // 采小助配置
  sundry:()=>import('@/views/configManage/sundry'), // 杂项配置
  aftersale: ()=>import('@/views/aftersale/aftersaleOrder'), // 售后管理
  aftersaleOrder: ()=>import('@/views/aftersale/aftersaleOrder'),
  refundOrder: ()=>import('@/views/aftersale/refundOrder'),
  orderManage: ()=>import('@/views/orderManage/cityWholesalerOrder'),
  cityWholesalerOrder: ()=>import('@/views/orderManage/cityWholesalerOrder'),
  originDealerOrder: ()=>import('@/views/orderManage/originDealerOrder'),
	pageConfig: ()=>import('@/views/pageConfig/floorConfig'),// 首页配置
  floorConfig: ()=>import('@/views/pageConfig/floorConfig'),// 首页楼层配置
  advertConfig: ()=>import('@/views/pageConfig/advertConfig'),// 广告图配置
  goodsRecommend: ()=>import('@/views/pageConfig/goodsRecommend'),// 商品推荐
  informationList: ()=>import('@/views/pageConfig/informationList'),// 资讯列表}
  // 物流管理
  logisticsDelivery:()=>import('@/views/logisticsDelivery/logisticsOrderManag'),
  logisticsOrderManag:()=>import('@/views/logisticsDelivery/logisticsOrderManag'), //物流订单管理
  transferDistribution:()=>import('@/views/logisticsDelivery/transferDistribution'),  //中转仓分配
  freightManage:()=>import('@/views/logisticsDelivery/freightManage'),  //运费配送
  // 页面配置
  businessCircleNews:()=>import('@/views/pageConfig/businessCircleNews'),  //生意圈资讯
  // 客户管理
  clientManage:()=>import('@/views/clientManage/relationManage'),
  relationManage:()=>import('@/views/clientManage/relationManage'), // 客户关系管理
  promoterManage:()=>import('@/views/clientManage/promoterManage'), // 推广员管理
  //采小助商品管理
  purchaseHelper:()=>import('@/views/purchaseHelper/purchaseCategory'),
  purchaseCategory:()=>import('@/views/purchaseHelper/purchaseCategory'), //采小助分类管理
  purchaseRecommend:()=>import('@/views/purchaseHelper/purchaseRecommend'), //采小助商品推荐
  purchaseSummary:()=>import('@/views/purchaseHelper/purchaseSummary'), //采小助汇总管理
  unrecordedSummary:()=>import('@/views/purchaseHelper/unrecordedSummary'), //未录入汇总
  quotationManage:()=>import('@/views/purchaseHelper/quotationManage'), //报价单管理
  // 报表管理
  reportList:()=>import('@/views/reportList/superMember'),
  superMember:()=>import('@/views/reportList/superMember'), //超级会员日
  blackListMember:()=>import('@/views/reportList/blackListMember'), //超级会员日  黑名单
  superMemberShang:()=>import('@/views/reportList/superMemberShang'), //超级会员日(商户)
  //  财务管理
  finance:()=>import('@/views/finance/posWithdraw'),
  posWithdraw:()=>import('@/views/finance/posWithdraw'),   //商户可提现
  dailySales:()=>import('@/views/finance/dailySales'),      //日销售明细
  withdrawalIncidental:()=>import('@/views/finance/withdrawalIncidental'),      //提现杂费报表
  financeLogistics:()=>import('@/views/finance/financeLogistics'),      //财务用物流报表
  financeLogisticsDetail:()=>import('@/views/finance/financeLogisticsDetail'),      //财务用物流明细报表
  categorySum:()=>import('@/views/finance/categorySum'),      //品种汇总表
  serviceRate:()=>import('@/views/finance/serviceRate'),      //服务费率报表
  productSales:()=>import('@/views/finance/productSales'),      //商品销售明细
  shopWithdrawalSum:()=>import('@/views/finance/shopWithdrawalSum'),      // 商户提现汇总
  productWithdrawalSum:()=>import('@/views/finance/productWithdrawalSum'),      // 提现商品汇总
  productWithdrawalDetail:()=>import('@/views/finance/productWithdrawalDetail'),      // 提现商品明细
  memberBalance:()=>import('@/views/finance/memberBalance'),      // 会员余额
  realTimeData:()=>import('@/views/finance/realTimeData'),       //实时数据
  creditList:()=>import('@/views/finance/creditList'),           //赊账订单管理
  mileageFreight:()=>import('@/views/finance/mileageFreight'),    //里程运费报表
  newLogisticsDetail:()=>import('@/views/finance/newLogisticsDetail'),  // 物流明细报表（新）
  rebateList:()=>import('@/views/finance/rebateList'),  //活动返利报表
  buyGiftsList:()=>import('@/views/finance/buyGiftsList'),  //买赠活动报表
  //  资金对账
  fund:()=>import('@/views/fund/fundDaily'),
  fundDaily:()=>import('@/views/fund/fundDaily'),  //会员卡日报表
  capitalDaily:()=>import('@/views/fund/capitalDaily'),  //资金日报表
  shopDaily:()=>import('@/views/fund/shopDaily') , //商户交易报表
  wxAccount:()=>import('@/views/fund/wxAccount'),  //微信对账表
  icbcAccount:()=>import('@/views/fund/icbcAccount'),  //聚合支付对账
  cashAccount:()=>import('@/views/fund/cashAccount'),  //现金余额报表
  //实时数据看板
  dataBoard:()=>import('@/views/dataBoard/index'),
  dataBoardData:()=>import('@/views/dataBoard/index')
}
// 动态路由转树结构
export function routesToTree(arr) {
  var arrs = []
  arr.forEach(item => {
    item.name = item.title;
    item.hidden = item.hidden == 2 ? true:false;
    item.meta = {
      title: item.title,
      icon: item.icon,
      affix: item.affix == 2 ? true : false,
      noCache: item.noCache == 2 ? true : false
    };
    if (item.parentId==0) {
      arrs.push(item)
    }
  })

  return arr.reduce((h, m) => {
    if (m.parentId != 0) {
      foo(h, m)
    }

    function foo(arr, cur) {
      arr.forEach(item => {
        if (item.id === cur.parentId) {
          if (!item.children) {
            item.children = []
          }
          item.children.push(cur)
        } else if (item.children) {
          foo(item.children, cur)
        }
      })
    }

    return h
  }, arrs)
}

// map对后台数据做路由映射
export function getMapRoutes(menuList){
  if(!menuList&&menuList.length===0)return [];
  menuList.forEach(item=>{
    item.component = routesMap[item.component];
  })
  // 报表系统的目录
  // 权限分配   || item.title == "sys" || item.title == "roleList"  || item.title == "adminList"
  var newMeun = []
  menuList.forEach(item=>{
    // if(item.title == "finance" || item.title == "posWithdraw" || item.title == "dailySales" || item.title == "withdrawalIncidental"
    //   || item.title == "financeLogistics" || item.title == "financeLogisticsDetail" || item.title == "fund" || item.title == "fundDaily"
    //   || item.title == "capitalDaily" || item.title == "shopDaily"|| item.title == "categorySum"
    //   || item.title == "serviceRate"|| item.title == "productSales"|| item.title == "shopWithdrawalSum"
    //   || item.title == "productWithdrawalSum" || item.title == "productWithdrawalDetail"
    //   || item.title == "memberBalance" || item.title== 'wxAccount' || item.title == "realTimeData" || item.title == 'icbcAccount') {
    //   newMeun.push(item)
    // }

    if(item.parentId == "207141450222362624" ||
      item.parentId == "205610376233181184"||
      item.parentId == "438361071481696256"||
      item.title == "finance" ||
      item.title == "fund"||
      item.title == "dataBoard"||
      item.title == "404" ) {
      newMeun.push(item)
    }




  })
  return newMeun;
}



// WEBPACK FOOTER //
// ./src/router/asyncRoutes.js